import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const coaches = ['https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=160&auto=format&fit=crop', 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=160&auto=format&fit=crop', 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=160&auto=format&fit=crop', 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?q=80&w=160&auto=format&fit=crop', 'https://images.unsplash.com/photo-1542178243-bc20204b769f?q=80&w=160&auto=format&fit=crop'];
export function SocialProof() {
  return <section className="bg-brand-dark px-4 py-6 md:py-8 border-y border-zinc-800/60" data-id="element-173">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-174">
        {/* Stacked avatars */}
        <div className="flex -space-x-3 shrink-0" data-id="element-175">
          {coaches.map((src, idx) => <img key={idx} src={src} alt={`Coach ${idx + 1}`} className="w-11 h-11 md:w-12 md:h-12 rounded-full object-cover border-2 border-brand-dark ring-1 ring-zinc-700" data-id="element-176" />)}
        </div>

        {/* Rating + caption */}
        <div className="text-center sm:text-left" data-id="element-177">
          <div className="flex items-center justify-center sm:justify-start gap-2" data-id="element-178">
            <div className="flex text-brand-orange" data-id="element-179">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-180" />)}
            </div>
            <span className="text-lg md:text-xl font-bold text-white font-oswald" data-id="element-181">
              4.9/5
            </span>
          </div>
          <p className="text-base md:text-xl font-bold text-white mt-0.5" data-id="element-182">
            +1,000 coaches worldwide{' '}
            <span role="img" aria-label="globe" data-id="element-183">
              🌍
            </span>
          </p>
        </div>
      </motion.div>
    </section>;
}